<template>
  <v-app>
    <div @click.capture="handleOutsideClick">
      
      <!-- App Bar -->
      <v-app-bar v-if="showAppChrome && !isPublicRoute" app elevation="0" color="white">
        <v-app-bar-nav-icon @click="drawer = !drawer">
          <v-btn
            dark
            icon
            rounded
            style="background: linear-gradient(145deg, #ff3b47, #5a1014); height: 35px; width: 36px; padding: 8px;"
          >
            <v-icon color="white">mdi-menu</v-icon>
          </v-btn>
        </v-app-bar-nav-icon>
        <div class="toolbar-title-container mx-5" :class="{ 'underline-active': underlineActive }">
          <v-toolbar-title class="toolbar-title" style="text-transform: uppercase;">{{ currentPageTitle }}</v-toolbar-title>
          <div class="underline"></div>
        </div>
        <v-spacer></v-spacer>
      </v-app-bar>

      <v-navigation-drawer v-if="showAppChrome && !isPublicRoute" 
        style="border-radius:0px 30px 30px 0px; background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%); border-right: 1px solid #34495e;" 
        v-model="drawer" 
        app
        @click.stop
      >
        <!-- Logo Section -->
        <v-list-item style="padding-bottom: 30px;">
          <v-img
            src="@/assets/newestlogo.jpg"
            max-height="120"
            style="border-radius:16px;"
            max-width="80"
            class="mx-auto my-8"
          ></v-img>
        </v-list-item>

        <!-- Version Chip -->
        <v-row justify="center" class="mb-4">
          <v-chip color="white" text-color="white" outlined>
            Version 14.4
          </v-chip>
        </v-row>

        <v-row justify="center" class="mb-5">
          <h2 class="white--text">Navigation Bar</h2>
        </v-row>

        <!-- Navigation List -->
        <v-list shaped dense style="padding: 0 20px;">
          <v-list-item-group v-model="clickedItem" color="white">
            <v-list-item
              v-for="(item, index) in filteredNavItems"
              :key="index"
              dark
              class="my-3"
              :class="{ 'selected-item': clickedItem === index, 'fade-in-animation': clickedItem === index }"
              @click="goToPage(item, index)"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <!-- Main Content -->
      <v-main :class="{ 'pa-0 ai-agent-main': $route.path === '/ai-agent', 'pa-0': isPublicRoute }">
        <router-view />
      </v-main>
    </div>
  </v-app>
</template>

<script>
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { firebaseApp } from "@/firebaseConfig";
import { SESSION_CREDENTIALS_KEY } from "@/utils/crossAppLoginUrl";

const auth = getAuth(firebaseApp);

export default {
  data() {
    return {
      drawer: false,
      clickedItem: null,
      underlineActive: false,
      currentPageTitle: 'Nexus Dashboard',
      navItems: [
        { icon: 'mdi-account-outline', text: 'Profile', route: '/profile' },
        { icon: 'mdi-briefcase-outline', text: 'Functions', route: '/Functions'},
        { icon: 'mdi-bell-ring-outline', text: 'Activity', route: '/Activity' },
        { icon: 'mdi-calendar-check-outline', text: 'Request Leave', route: '/RequestLeave' },
        { icon: 'mdi-account', text: 'Admin Section', route: '/AdminSection', requiresAdmin: true },
        { icon: 'mdi-bug', text: 'Report Bug', route: '/ReportBug' },
        { icon: 'mdi-logout-variant', text: 'Logout', route: '/' },
      ],
      userRole: localStorage.getItem('role') || '',
    };
  },
  computed: {
     isPublicRoute() {
    return this.$route.meta.public === true
  },
    showAppChrome() {
      const p = this.$route.path;
      return p !== '/' && p !== '/forgotPassword' && p !== '/ai-agent';
    },
    isPublicRoute() {
      return this.$route.meta.public === true
    },
    showAppChrome() {
      const p = this.$route.path;
      return p !== '/' && p !== '/forgotPassword' && p !== '/ai-agent';
    },
    filteredNavItems() {
      return this.navItems.filter(item => {
        if (item.requiresProcurement) {
          return this.userRole === 'procurement';
        }
        if (item.requiresAdminOrEngineer) {
          return this.userRole === 'Admin' || this.userRole === 'Engineer' || this.userRole === 'Salesperson' || this.userRole === 'Technician' || this.userRole === 'procurement' || this.userRole === 'Stores'||this.userRole==='Debtors';
        }
        return !(item.requiresAdmin && this.userRole !== 'Admin');
      });
    }
  },
 created() {
  // Wait for auth to initialize before checking
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user) {
      console.log('User authenticated:', user.uid);
    } else if (!this.isPublicRoute && this.$route.path !== '/' && this.$route.path !== '/forgotPassword') {
      this.$router.push('/');
    }
  });

  // Store unsubscribe to clean up later if needed
  this.$once('hook:beforeDestroy', () => {
    unsubscribe();
  });

  this.checkUserRole();
  this.updatePageTitle();
  this.underlineActive = true;
  this.$router.afterEach((to) => {
    this.updatePageTitle();
  });
},
  methods: {
    goToPage(item, index) {
      this.clickedItem = index;
      const page = item.route;
      const text = item.text;
      if (text === 'Logout') {
        localStorage.clear();
        sessionStorage.removeItem(SESSION_CREDENTIALS_KEY);
      }
      if (this.$route.path !== page) {
        this.$router.push(page).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    checkUserRole() {
      setInterval(() => {
        this.userRole = localStorage.getItem('role');
      }, 1000);
    },
    updatePageTitle() {
      const routeToTitleMap = {
        '/profile': 'Profile',
        '/Functions': 'Functions',
        '/Activity': 'Activity',
        '/ai-agent': 'AI Agent',
        '/AllReport': 'Report',
        '/RequestLeave': 'Request Leave',
        '/AdminSection': 'Admin Section',
        '/ReportBug': 'Report Bug',
        '/AllPO': 'ALL PURCHASE ORDER',
        '/AllSalesTracker':'SO TRACKER',
        '/EditSalesTracker':'EDIT SO TRACKER',
        'AddSalesTracker':'ADD SO TRACKER'
      };

      const currentRoute = this.$route.path;
      const routeName = routeToTitleMap[currentRoute] || this.formatRouteName(currentRoute);
      this.currentPageTitle = routeName;
    },
    formatRouteName(route) {
      return route
        .replace(/^\//, '')
        .replace(/([A-Z])/g, ' $1')
        .replace(/-/g, ' ')
        .trim();
    },
    handleOutsideClick() {
      if (this.drawer) {
        this.drawer = false;
      }
    },
  }
};
</script>

<style>
/* Global Vuetify Overrides */
.v-application {
  font-family: 'Inter', sans-serif !important;
  background: linear-gradient(135deg, #475569 0%, #334155 100%) !important;
  color: white !important;
}

/* Ensure main content background matches */
.v-main {
  background: linear-gradient(135deg, #475569 0%, #334155 100%) !important;
}

.v-main.ai-agent-main {
  min-height: 100vh !important;
  /* allow fixed overlays (AI tray) to sit past main; iframe is contained by AiAgent.vue */
  overflow: visible !important;
}

/* Optional: Override Vuetify default colors */
:root {
  --v-primary-base: #475569;
  --v-primary-lighten1: #334155;
  --v-primary-darken1: #1e293b;
}
</style>

<style scoped>
/* Toolbar title container */
.toolbar-title-container {
  display: inline-block;
  position: relative;
}

/* Styling for the title */
.toolbar-title {
  font-weight: bold;
  display: inline-block;
  padding-bottom: 5px;
  position: relative;
}

/* Hidden underline */
.underline {
  content: "";
  display: block;
  width: 0;
  height: 5px;
  background-color: red;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: width 0.3s ease-in-out;
}

/* Activate underline on route change */
.underline-active .underline {
  width: 80%;
}

/* Fade-in animation for selected item */
.fade-in-animation {
  animation: fadeIn 0.5s ease-in-out forwards;
}

/* Keyframes for fade-in */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Styles for selected item */
.selected-item {
  background-color: #23262b !important;
  color: white!important;
}

.selected-item .v-icon,
.selected-item .v-list-item-title {
  color: white !important;
}

.v-list-item-title {
  font-weight: bold;
}

/* Styles for the version chip */
.v-chip {
  font-weight: bold;
}
/* Navigation item styling for Option 2 look */
.v-list-item {
  border-radius: 8px !important;
  margin-bottom: 8px !important;
  position: relative;
}

.v-list-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: white;
  border-radius: 0 4px 4px 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.v-list-item--active::before,
.selected-item::before {
  opacity: 1;
}

.v-list-item:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.v-list-item--active,
.selected-item {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.v-list-item .v-icon {
  color: white !important;
}

.v-list-item .v-list-item-title {
  color: white !important;
}
/* Remove logo hover effects */
.v-image {
  transition: none !important;
}

.v-image:hover {
  transform: none !important;
  box-shadow: none !important;
  filter: none !important;
}

.v-list-item:hover .v-image {
  transform: none !important;
  box-shadow: none !important;
  filter: none !important;
}
</style>
